// Cross-locale/language constants to be used during runtime
// to increase developer convenience and enable validation
// and sanitization in stores for example.
// Beware of code vs. configuration (@see https://12factor.net/config)
// @todo check whether to add to .env file
export default Object.freeze({
    pricePeriods: {
        default: 0,
        week: 1,
        month: 2,
        overmonth: 3
    },
    priceFormats: {
        default: 0,
        monthly: 1
    },
    requestStatuses: {
        default: null,
        pending: 2,
        succeeded: 1,
        failed: 0
    },
    checkout: {
        inquiryTypes: {
            nonBinding: 0,
            binding: 1
        }
    }
})
